import { Avatar, KeyValueCustomSelect, TeamPill } from "@smartsuite/react-ui/lib";
import { Team as SmartSuiteTeam } from "@smartsuite/types";
import React, { ReactNode } from "react";
import { Team } from "../../../../types/form";
import { $t } from "../../../../utils/intl";
import { UseFormFieldResult } from "../../../../hooks/useFormField";
import { fieldsStateText, fieldsText } from "../../fields.text";
import { TeamFormValue } from "../team.config";
import { ensureTeamColor } from "./ensureTeamColor";

interface TeamFieldSingleProps {
  options: TeamFormValue[];
  formField: UseFormFieldResult<Team[]>;
  readOnly?: boolean;
  isLoading: boolean;
  onChange: (value: Team | Team[]) => void;
}

export const TeamFieldSingle: React.FunctionComponent<TeamFieldSingleProps> = ({
  options,
  formField,
  readOnly,
  isLoading,
  onChange,
}) => {
  const renderOption = (option: TeamFormValue): ReactNode => {
    const color = option.team.color?.[0]?.value ?? "#4B5563";
    return (
      <div className="team-field-single-option">
        <Avatar size="m" initials={option.name[0]} color={color} />
        <span>{option.name}</span>
      </div>
    );
  };

  const renderSelectedOption = (option: TeamFormValue): ReactNode => (
    <TeamPill team={ensureTeamColor(option.team) as unknown as SmartSuiteTeam} />
  );

  return (
    <KeyValueCustomSelect<"team", "name", TeamFormValue>
      placeholderArrowStyle="arrow-down-smaller"
      clearIconName="close-thin"
      disabled={readOnly}
      isReadOnly={readOnly}
      allowSelection={!readOnly}
      labelField="name"
      options={options}
      renderOption={renderOption}
      renderSelectedOption={renderSelectedOption}
      showPlaceholderArrow={!readOnly}
      showClear={!readOnly}
      placeholder={isLoading ? $t(fieldsStateText.loading) : $t(fieldsText.singleSelectPlaceholder)}
      searchPlaceholder={$t(fieldsText.singleSelectSearchOptionPlaceholder)}
      showFilterGreaterThan={4}
      state={formField.state}
      value={formField.value?.[0]}
      valueField="team"
      valueFieldPath="id"
      virtualized={true}
      itemHeight={36}
      onChange={onChange}
      onChangeFocused={formField.onChangeFocused}
    />
  );
};
